import React, {useContext} from "react";
import {
  Button,
  Col,
  CustomInput, FormGroup,
  Input,
  InputGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader, Row, Collapse, Card, CardBody, UncontrolledCollapse, InputGroupAddon
} from "reactstrap";
import {observer} from "mobx-react-lite";
import RuleSetSelectView from "../../../elements/ruleSets/RuleSetSelectView";
import CreateRuleForm from "../create/CreateRuleForm";
import {CreateRuleSetState} from "../create/CreateRuleSetState";
import {StateContext} from "../../../../App";
import CreateCode from "../../../codes/create/CreateCodeDomain";
import {browserHistory, useRouterStore} from "mobx-state-router";
import {FormattedMessage} from "react-intl";
import GroupSelect from "../../../elements/groups/GroupSelect";
import DisableWrapper from "../../../../utils/disableWrapper";

const RuleSetModalView =  observer(({store, currentState}) => {
  const routerStore = useRouterStore();
  const { params } = routerStore.routerState;

  const stateContext = useContext(StateContext);
  // const editCodeState = stateContext.rootUiStore.editCodeState
  // const createCodeViewState = stateContext.rootUiStore.createCodeViewState
  //TODO: PATTERN VIOLATIONS - Multiple state-modifying operations called on every render:
  // 1. Line 32: store.ruleSetSelectState.setConsumer() - State-modifying method on every render
  // 2. Line 35: store.ruleSetSelectState.store.setFilterOn() - State-modifying method on every render
  // Correct solution: Move all state initialization/modification to route onEnter or MST actions
  // See correct pattern: src/routes/codes/index.js onEnter handlers for state initialization
  store.ruleSetSelectState.setConsumer(store.createRuleSetState.fetchRuleSetWithID)
  //const selectedGroupUUid = !params.id? createCodeViewState.groupSelectStore?.selectedGroup?.uuid : editCodeState?.groupSelectStore?.selectedGroup?.uuid
  const selectedGroupUUid = stateContext.rootUiStore?.groupSelectStore?.selectedGroup?.uuid
  store.ruleSetSelectState.store.setFilterOn(selectedGroupUUid)
  const isDisabled = store.isView;

  return (
    <Card>
      <CardBody>
        <DisableWrapper isDisabled={isDisabled}>

                  <Row>
                    <Col sm={2}>
                    <FormGroup check>
                      <Input name="ruleSet"
                             type="radio"
                             id="customOpen"
                             value={store.customOpen}
                             checked={store.customOpen}
                             onClick={() => {store.setCustomOpen()}}
                      />
                       <Label check>
                        <FormattedMessage id="createQr.advancedConfigsOptions.modalButtons.new.defaultMessage"/>
                      </Label>
                    </FormGroup>
                    </Col>
                    {store.customOpen &&
                      <>
                      <Col sm={6} >
                        <InputGroup className="mb-3">
                          <InputGroupAddon addonType="prepend">
                            Autofill From
                          </InputGroupAddon>
                          <RuleSetSelectView store={store.ruleSetSelectState} disabled={isDisabled} />
                        </InputGroup>
                      </Col>
                      </>
                    }
                    <Col sm={2}>
                    <FormGroup check>
                      <Input name="ruleSet"
                             type="radio"
                             id="noUtmSelectButton"
                             value={store.noRuleOpen}
                             checked={store.noRuleOpen}
                             onClick={() => {store.setNoneOpen()}}
                      />
                      <Label check>
                        None
                      </Label>
                    </FormGroup>
                    </Col>
                    {/*<FormGroup check>*/}
                    {/*  <Input name="ruleSet"*/}
                    {/*         type="radio"*/}
                    {/*         id="utmCustomSelectButton"*/}
                    {/*         value={store.customOpen}*/}
                    {/*         checked={store.customOpen}*/}
                    {/*         onClick={() => {store.setCustomOpen()}}*/}
                    {/*  />*/}
                    {/*  <Label check>*/}
                    {/*    Custom*/}
                    {/*  </Label>*/}
                    {/*</FormGroup>*/}
                  </Row>
            {/*<Col sm={1}  >*/}
            {/*</Col>*/}
              <Col sm={3}  >

            </Col>
          {(store.customOpen || store.presetsOpen) && <CreateRuleForm createRuleSetState={store.createRuleSetState}/>}
          {/*<Col sm={1}>*/}
          {/*  <Button color="primary" onClick={async () => {*/}
          {/*    editCodeState && editCodeState.modalStore.toggle()*/}
          {/*    createCodeViewState && createCodeViewState.modalStore.toggle()*/}
          {/*  }}> Close*/}
          {/*  </Button>*/}
          {/*</Col>*/}
          {/*{(store.presetsOpen || store.customOpen) && <><FormInputs state={store}/>*/}
          {/*  Add name if you want save these inputs as a new preset*/}
          {/*  <Row className="p-1">*/}
          {/*    <Label sm={2} className="text-sm-right">Name</Label>*/}
          {/*    <Col sm={7}>*/}
          {/*      <div className="custom-controls-stacked">*/}
          {/*        <Input*/}
          {/*          type="input"*/}
          {/*          id="name"*/}
          {/*          name="name"*/}
          {/*          onChange={store.handleNameChange}*/}
          {/*          value={store.name}*/}
          {/*        />*/}
          {/*      </div>*/}
          {/*    </Col>*/}
          {/*    <Col sm={1}>*/}
          {/*      <Button color="primary" onClick={async () => {*/}
          {/*        const res = await store.addUtm()*/}
          {/*        if (res) {*/}
          {/*          toastr.success("Success", `you saved ${store.name} as a new Preset`)*/}
          {/*        } else {*/}
          {/*          toastr.error("Failure", `Sorry ${store.name} did not save`)*/}
          {/*        }*/}
          {/*      }*/}
          {/*      }> <FormattedMessage id="qrDesign.create.save.defaultMessage"/>*/}
          {/*      </Button>*/}
          {/*    </Col>*/}

          {/*  </Row>*/}
          {/*</>*/}

          {/*}*/}
          <Row className="p-1">
            <Col sm={2}>
              <Button id="cancel-btn" color="secondary" onClick={async () => {
                // editCodeState && editCodeState.modalStore.toggle()
                // createCodeViewState && createCodeViewState.modalStore.toggle()
                currentState.ruleSetModalState.setOpenView()
                currentState.modalStore.toggle()
              }}>
                <FormattedMessage id="createQr.advancedConfigsOptions.modalButtons.cancel.defaultMessage" />
              </Button>
            </Col>
            <Col sm={10} className="text-right">
              <Button id="apply-btn" outline color="primary"   onClick={async () => {
                // if (createCodeViewState) {
                //   const resp = await createCodeViewState.addRulesToCode()
                //   if (resp) {
                //     createCodeViewState.modalStore.toggle()
                //   }
                // }
                // if (editCodeState) {
                //   const resp = await editCodeState.addRulesToCode()
                //   if (resp) {
                //     editCodeState.modalStore.toggle()
                //   }
                // }
                currentState.addRulesToCode()
                currentState.modalStore.toggle()
              }}>
                <FormattedMessage id="createQr.advancedConfigsOptions.modalButtons.apply.defaultMessage" />
              </Button>
            </Col>
          </Row>
        </DisableWrapper>
      </CardBody>
    </Card>

  );
})

export default RuleSetModalView;
